// 单独处理的白名单
export const apiErrorWhitelist = {
  4000: ['/health-doctor-assistant/workOrderCenter/v2/handle'],
  4008: ['/health-user/patient-portrait/refresh']
}

// 后台静默接口：失败时不弹全局错误通知，仍 reject 交给调用方自行处理。
// （画像轮询/已读上报/任务恢复属高频或无感操作，弹全局通知会造成打扰）
export const silentErrorApis = [
  '/health-user/patient-portrait/refresh/status',
  '/health-user/patient-portrait/read',
  '/health-user/patient-portrait/refresh/processing'
]
